import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';
import { getCurrentUserId } from './auth-helper';
import { createSettingsItem, loadSettings } from './db-settings';
import { firebaseApp } from './config';
import { DroneStats, LocationStat, PilotStats } from '../interfaces/StatsType';
import { FilterType } from '../interfaces/FilterType';

const db = getFirestore(firebaseApp);

function createDroneStatsItem(data: any): DroneStats {
  return {
    droneId: data.droneId,
    totalFlightTime: data.totalFlightTime,
    totalFlightCount: data.totalFlightCount,
    maxFlightHeigth: data.maxFlightHeigth,
    maxFlightSpeed: data.maxFlightSpeed,
  };
}
function createPilotStatsItem(data: any): PilotStats {
  return {
    pilotId: data.pilotId,
    totalPilotTime: data.totalPilotTime,
    totalAnalystTime: data.totalAnalystTime,
    totalObserverTime: data.totalObserverTime,
    totalPilotCount: data.totalPilotCount,
    totalAnalystCount: data.totalAnalystCount,
    totalObserverCount: data.totalObserverCount,
    totalFlightTimes: data.totalFlightTimes,
  };
}
function createDroneStatsDemo(): DroneStats {
  return {
    droneId: 'N/A',
    totalFlightTime: 0,
    totalFlightCount: 0,
    maxFlightHeigth: 0,
    maxFlightSpeed: 0,
  };
}
function createPilotStatsDemo(): PilotStats {
  return {
    pilotId: 'N/A',
    totalPilotTime: 0,
    totalAnalystTime: 0,
    totalObserverTime: 0,
    totalPilotCount: 0,
    totalAnalystCount: 0,
    totalObserverCount: 0,
    totalFlightTimes: [],
  };
}

export async function loadDoneStats(droneId: string | number) {
  try {
    console.log('loadDoneStats');
    const uid = getCurrentUserId();
    if (!uid) return createDroneStatsDemo();

    const settings = await loadSettings();
    let zugriffscode: string | undefined = undefined;
    if (settings === undefined) {
      return createDroneStatsDemo();
    } else {
      const zugangscode = settings.zugangscode;
      if (settings.zugangscode !== createSettingsItem({}).zugangscode) {
        console.log('Zugriffscode gefunden');
        zugriffscode = zugangscode;
      }
    }
    let q = query(
      collection(db, 'users', zugriffscode ? zugriffscode : uid, 'stats'),
      where('droneId', '==', droneId)
    );

    const querySnapshot = await getDocs(q);
    let result = createDroneStatsDemo();

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      result = createDroneStatsItem(data);
    });
    return result;
  } catch (error) {
    console.error('Fehler beim Laden der Logs:', error);
  }
}
export async function loadPilotStats(pilotId: string) {
  try {
    console.log('loadPilotStats');
    const uid = getCurrentUserId();
    if (!uid) return createPilotStatsDemo();

    const settings = await loadSettings();
    let zugriffscode: string | undefined = undefined;
    if (settings === undefined) {
      return createPilotStatsDemo();
    } else {
      const zugangscode = settings.zugangscode;
      if (settings.zugangscode !== createSettingsItem({}).zugangscode) {
        console.log('Zugriffscode gefunden');
        zugriffscode = zugangscode;
      }
    }
    let q = query(
      collection(db, 'users', zugriffscode ? zugriffscode : uid, 'stats'),
      where('pilotId', '==', pilotId)
    );

    const querySnapshot = await getDocs(q);
    let result = createPilotStatsDemo();

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      result = createPilotStatsItem(data);
    });
    return result;
  } catch (error) {
    console.error('Fehler beim Laden der Logs:', error);
  }
}
export async function loadLocationStats(): Promise<LocationStat[]> {
  try {
    console.log('loadPilotStats');
    const uid = getCurrentUserId();
    if (!uid) return [];

    const settings = await loadSettings();
    let zugriffscode: string | undefined = undefined;
    if (settings === undefined) {
      return [];
    } else {
      const zugangscode = settings.zugangscode;
      if (settings.zugangscode !== createSettingsItem({}).zugangscode) {
        console.log('Zugriffscode gefunden');
        zugriffscode = zugangscode;
      }
    }
    let q = query(
      collection(db, 'users', zugriffscode ? zugriffscode : uid, 'stats'),
      where('id', '==', 'locations')
    );

    const querySnapshot = await getDocs(q);
    let result: LocationStat[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      result = data.allLocations;
    });
    result = result.filter((item) => item.location != '');
    return result;
  } catch (error) {
    console.error('Fehler beim Laden der Logs:', error);
    return [];
  }
}

export async function updateStats(includes: FilterType[]) {
  const uid = getCurrentUserId();
  const settings = await loadSettings();
  let zugriffscode: string | undefined = undefined;
  if (settings === undefined) {
    return createDroneStatsDemo();
  } else {
    const zugangscode = settings.zugangscode;
    if (settings.zugangscode !== createSettingsItem({}).zugangscode) {
      console.log('Zugriffscode gefunden');
      zugriffscode = zugangscode;
    }
  }

  const url = `https://backend.drohne.es/generate-stats`;
  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_BACKEND_TOKEN || ''}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: zugriffscode ? zugriffscode : uid,
        includes,
        type: includes[0].field === 'droneType' ? 'drone' : includes[0].field,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}

export async function getBackendVersion() {
  const url = `https://backend.drohne.es/node-version`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_BACKEND_TOKEN || ''}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);
    return data.version;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}
